import { render, staticRenderFns } from "./SimilarContent.vue?vue&type=template&id=59cbaecc"
import script from "./SimilarContent.vue?vue&type=script&lang=js"
export * from "./SimilarContent.vue?vue&type=script&lang=js"
import style0 from "./SimilarContent.vue?vue&type=style&index=0&id=59cbaecc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports